import { useEffect, useState, useRef } from 'react';
import { API_URL } from '../../shared/constant';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import Select from 'react-select';
import DatePicker from "react-date-picker";
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import swal from 'sweetalert2';
import Loader from "../../shared/loader";

const SearchLedger = () => {

    const [showAction, setShowAction] = useState(true);
    const [partyId, setPartyId] = useState(0);
    const [data, setData] = useState([]);
    const [partyData, setPartyData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [totalQty, setTotalQty] = useState(0);
    const [debitBillAmonnt, setDebitBillAmonnt] = useState(0);
    const [debitCashAmount, setDebitCashAmount] = useState(0);
    const [debitTotal, setDebitTotal] = useState(0);
    const [creditBillAmonnt, setCreditBillAmonnt] = useState(0);
    const [creditCashAmount, setCreditCashAmount] = useState(0);
    const [creditTotal, setCreditTotal] = useState(0);
    const [totalCashAmount, setTotalCashAmount] = useState(0);
    const [totalBillAmount, setTotalBillAmount] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);
    const [loading, setLoading] = useState(true);

    const [openingAmount, setOpeningAmount] = useState({
        is_opening: false,
        balance_amount: 0,
        credit_bill_total: 0,
        credit_cash_total: 0,
        credit_total: 0,
        debit_bill_total: 0,
        debit_cash_total: 0,
        debit_total: 0
    });
    const reportTemplateRef = useRef(null);
    const selectRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        getParty();
    }, []);

    const downloadPdf = () => {
        setLoading(true);
        setShowAction(false);
        var element = document.getElementById('element-to-print');
        const pDetail = partyData.find(pt => pt.value == partyId);
        setTimeout(() => {
            var opt = {
                margin: 0.1,
                filename: pDetail.label + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 4 },
                pagebreak: { mode: 'avoid-all' },
                jsPDF: { unit: 'in', format: 'a3', orientation: 'landscape' }
            };
            html2pdf().set(opt).from(element).save().then(res => {
                setLoading(false);
            });
            setShowAction(true);
        }, 200);
    }

    const clearFilter = () => {
        setLoading(true);
        setStartDate(null);
        setEndDate(null);
        setTimeout(() => {
            selectRef.current.clearValue();
        }, 200);
    }

    const getParty = () => {
        setLoading(true);
        axios.post(API_URL.PARTY_LIST, { status: 1 }).then(res => {
            let pt = res.data.data.map((row) => {
                return {
                    value: row.id,
                    label: row.name
                }
            })
            setPartyData(pt);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    };

    const changeParty = (party_id, from_date, to_date) => {
        setLoading(true);
        setPartyId(party_id);
        let params = {
            user_id: party_id,
            from_date: (from_date) ? moment(from_date).format("YYYY-MM-DD") : null,
            to_date: (to_date) ? moment(to_date).format("YYYY-MM-DD") : null,
        }
        axios.post(API_URL.LEDGER_LIST, params).then(res => {
            setData(res.data.data);
            setTotalQty(res.data.total_qty);
            setDebitBillAmonnt(res.data.debit_bill_total);
            setDebitCashAmount(res.data.debit_cash_total);
            setDebitTotal(res.data.debit_total);
            setCreditBillAmonnt(res.data.credit_bill_total);
            setCreditCashAmount(res.data.credit_cash_total);
            setCreditTotal(res.data.credit_total);
            setFinalAmount(res.data.finalAmount);
            let tcash = res.data.debit_cash_total - res.data.credit_cash_total;
            let tbill = res.data.debit_bill_total - res.data.credit_bill_total;
            setTotalCashAmount(tcash);
            setTotalBillAmount(tbill);
            setOpeningAmount(res.data.opening);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    };

    const searchDataByDate = (fromDate, toDate) => {
        if (fromDate && toDate) {
            changeParty(partyId, fromDate, toDate);
        }
        if (!fromDate && !toDate) {
            setLoading(true);
            changeParty(partyId, null, null);
        }
    };

    const goToEdit = (row) => {
        navigate('/admin/payment/edit/' + row.id);
    }

    const goToDelete = (row) => {
        swal({
            title: "Are you sure want to delete?",
            icon: "warning",
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            buttons: true
        }).then((willDelete) => {
            if (willDelete) {
                if (row.payment_view == 'Purchase') {
                    onDelete(row.payment_view_id, API_URL.ADMIN_PURCHASE_DELETE);
                } else if (row.payment_view == 'Sales') {
                    onDelete(row.payment_view_id, API_URL.ADMIN_SALES_DELETE);
                } else {
                    onDelete(row.id, API_URL.ADMIN_PAYMENT_DELETE);
                }
            }
        });
    }

    const onDelete = (id, url) => {
        setLoading(true);
        axios.post(url, { id: id }).then((response) => {
            if (response.data.status == 1) {
                changeParty(partyId, startDate, endDate);
            } else {
                toast.error(response.data.data);
            }
            setLoading(false);
        });
    };

    return (<>
        <div className="page-header">
            <div className="content-page-header">
                <div className="d-flex">
                    <h5 className="me-1">Ledger </h5>
                </div>
            </div>
        </div>
        <div className='d-flex'>
            <div className='col-md-6 d-flex gap-2'>
                <div className="col-md-6">
                    <div className="form-group">
                        <Select ref={selectRef} placeholder={'Select Party'} value={partyData.find(pt => pt.value == partyId)} options={partyData} onChange={(e) => changeParty((e ? e.value : 0), startDate, endDate)} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <DatePicker
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            className="form-control input-sm"
                            selected={startDate}
                            clearIcon={startDate ? undefined : null}
                            onChange={(date) => [
                                setStartDate(date),
                                searchDataByDate(date, endDate),
                            ]}
                            value={startDate}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <DatePicker
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            className="form-control input-sm"
                            selected={endDate}
                            clearIcon={endDate ? undefined : null}
                            onChange={(date) => [
                                setEndDate(date),
                                searchDataByDate(startDate, date),
                            ]}
                            value={endDate}
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-sm-12 text-end">
                {(partyId || startDate || endDate) && (
                    <button
                        type="button"
                        className="btn btn-danger me-2"
                        onClick={clearFilter}
                    >
                        <i class="fa-solid fa-xmark me-2"></i>
                        Clear Filter
                    </button>
                )}
                <button
                    type="button"
                    disabled={(!partyId || !data.length)}
                    className="btn btn-primary"
                    onClick={() => downloadPdf()}
                >
                    <i class="fa-solid fa-arrow-down me-2"></i>
                    Download
                </button>

            </div>
        </div>
        {loading && <Loader></Loader>}
        {!loading && data.length > 0 && (
            <div className='card payments'>
                <div className='card-body'>
                    <div className="fz14">
                        <div className="table-responsive" ref={reportTemplateRef} id="element-to-print">
                            <table className='table table-hover table-bordered m-0'>
                                <tbody>
                                    <tr>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} colSpan={2}>
                                            {(partyId && partyId > 0) ? (partyData.find(pt => pt.value == partyId).label) : ""}
                                        </th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-center" colSpan={2}>Debit</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-center" colSpan={2}>Credit</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end" colSpan={1}>Total</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end" colSpan={1}></th>
                                        {showAction && <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end hidden-print" colSpan={1}></th>}
                                    </tr>
                                    <tr>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px', minWidth: 73 }}>Date</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }}>Particulars</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">Bill</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">Total</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">Bill</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">Total</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">Balance</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-center">Days</th>
                                        {showAction && <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px', width: 90 }} className="text-end hidden-print">Action</th>}
                                    </tr>
                                    {openingAmount.is_opening &&
                                        <tr>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end' colSpan={2}>Opening Balance - ({moment(startDate).format("DD/MM/YYYY")} to {moment(endDate).format("DD/MM/YYYY")})</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end text-primary'>{openingAmount.debit_bill_total.toFixed(2)}</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{openingAmount.debit_total.toFixed(2)}</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end text-primary'>{openingAmount.credit_bill_total.toFixed(2)}</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{openingAmount.credit_total.toFixed(2)}</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{(Math.abs(openingAmount.balance_amount)).toFixed(2)} {(openingAmount.balance_amount > 0) ? 'Cr' : 'Dr'}</th>
                                            <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-center'></th>
                                            {showAction && <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end hidden-print"></th>}
                                        </tr>
                                    }
                                    {
                                        data.map((elem, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }}>{elem.date}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }}>
                                                        <div style={{ minHeight: 30 }}>{elem.invoice_no}<span>{(elem.invoice_no && elem.remark) ? ' - ' : ''} {elem.remark}</span>{(elem.is_opening == 1) ? <span>Opening</span> : ""}</div>
                                                    </td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end text-primary">{elem.dr_bill.toFixed(2)}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">{elem.dr_total.toFixed(2)}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end text-primary">{elem.cr_bill.toFixed(2)}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end">{elem.cr_total.toFixed(2)}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className={(elem.balance_amount > 0) ? 'text-end text-success' : 'text-end'}>{(Math.abs(elem.balance_amount)).toFixed(2)} {(elem.balance_amount > 0) ? 'Cr' : 'Dr'}</td>
                                                    <td style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-center">{moment().diff(moment(elem.date, "DD/MM/YYYY"), 'days')}</td>
                                                    {showAction && <td style={{ verticalAlign: 'top', textAlign:"center", fontSize: 16, padding: '0px 5px 12px' }} className="text-end hidden-print">
                                                        <i className='fa fa-edit me-2' onClick={() => goToEdit(elem)}></i>
                                                        <i className='fa fa-trash-alt' onClick={() => goToDelete(elem)} ></i>
                                                    </td>}
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end' colSpan={2}>Total</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end text-primary'>{debitBillAmonnt.toFixed(2)}</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{debitTotal.toFixed(2)}</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end text-primary'>{creditBillAmonnt.toFixed(2)}</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{creditTotal.toFixed(2)}</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end'>{(Math.abs(finalAmount)).toFixed(2)} {(finalAmount > 0) ? 'Cr' : 'Dr'}</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-center'></th>
                                        {showAction && <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end hidden-print"></th>}
                                    </tr>
                                    <tr>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end' colSpan={6}>Final Amount</th>
                                        <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className='text-end' colSpan={1}>{(Math.abs(finalAmount)).toFixed(2)} {(finalAmount > 0) ? 'Cr' : 'Dr'}</th>
                                        <th></th>
                                        {showAction && <th style={{ verticalAlign: 'top', fontSize: 16, padding: '0px 5px 12px' }} className="text-end hidden-print"></th>}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {!loading && data.length === 0 && <div className="d-flex justify-content-center info-text">No Data Found. Please select any pary name...</div>}
    </>
    )
}

export default SearchLedger 